import React from "react";
import { Grid, Button, Icon, Header } from 'semantic-ui-react';

let server_url = process.env.REACT_APP_SERVER_URL;

if (!server_url || server_url === "") {
    server_url = `${window.location.protocol}//${window.location.hostname}`;
    if (window.location.port !== "") {
        server_url = `${server_url}:${window.location.port}`;
    }
}

const Helpers = {
    httpRequest: async (url, method, jwtToken) => {

        const config = {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`
            }
        };

        const response = await fetch(url, config);
        const body = await response.json();
        return body

    },
};

class SettingPane extends React.Component {
    state = {
        loading: false,
        errors: null,
    }

    closeDock() {
        this.props.handleConfigVisibleChange(false)
    }

    getAppCache = async (event) => {
        this.setState({
            loading: true,
        });

        const appcache = await Helpers.httpRequest(
            `${server_url}/appcache`,
            'get',
            this.props.jwtToken
        );

        this.setState({
            loading: false
        });

        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(appcache));
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", "appcache.json");
        document.body.appendChild(downloadAnchorNode);
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    }

    render() {
        let windowHeight = window.innerHeight;
        const { loading } = this.state;

        let appCacheButton = null;

        if (this.props && this.props.user && this.props.user.isPlatformUser) {
            appCacheButton = <Button disabled={loading} className="button-submit" onClick={this.getAppCache}>
                {(loading) ? 'Downloading...' : 'Download'} Application Cache
                              </Button>
        }

        return (
            <React.Fragment>
                <h4 className="pane_header">
                    Config Pane
                    <Icon name="close" className="closeIcon" onClick={() => this.closeDock()} />
                </h4>
                <Grid className="settingPane" style={{ maxHeight: windowHeight - 52, overflow: "auto" }}>
                    <Grid.Row columns={1}>
                        <Grid.Column>
                            {appCacheButton}
                        </Grid.Column>
                    </Grid.Row>

                </Grid>
            </React.Fragment>
        );
    }
}
export default SettingPane;
